export const size = {
    size12: 12,
    size20: 20,
    size30: 30,
    size40: 40,
    size60: 60,
    size100: 150,
    size600: 600,
}